import { Extension } from '@tiptap/core'
import ActionButton from '@/notebook/components/ActionButton.vue'
import { useTiptapStore } from '@/notebook/hooks'
import type { GeneralOptions } from '@/notebook/type'

export type PrinterOptions = {} & GeneralOptions<PrinterOptions>

const { togglePrinter, state } = useTiptapStore()

export const Printer = Extension.create<PrinterOptions>({
  name: 'printer',
  addOptions() {
    return {
      ...this.parent?.(),
      button: ({ editor, extension, t }) => ({
        component: ActionButton,
        componentProps: {
          tooltip: t('editor.printer.tooltip'),
          action: () => togglePrinter(),
          icon: 'Printer',
          shortcutKeys: ['mod', 'P'],
          isActive: () => state.printer,
        },
      }),
    }
  },
})
